/**
 * @generated SignedSource<<434258b5c930d585093e2363bb72efe3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type setAsDefaultItem_navigationKitTabMenuOld$data = {
  readonly __id: string;
  readonly id: string;
  readonly isDefault: boolean;
  readonly label: string;
  readonly " $fragmentType": "setAsDefaultItem_navigationKitTabMenuOld";
};
export type setAsDefaultItem_navigationKitTabMenuOld$key = {
  readonly " $data"?: setAsDefaultItem_navigationKitTabMenuOld$data;
  readonly " $fragmentSpreads": FragmentRefs<"setAsDefaultItem_navigationKitTabMenuOld">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "setAsDefaultItem_navigationKitTabMenuOld",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "isDefault"
      },
      "action": "THROW",
      "path": "isDefault"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "label"
      },
      "action": "THROW",
      "path": "label"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "__id"
          },
          "action": "THROW",
          "path": "__id"
        }
      ]
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "c23cfeb3a5a0ee268d038559efd42314";

export default node;
